import axios from 'axios'

export default axios.create({
    // baseURL: "http://localhost/gfesupport/api/"
    baseURL: "http://www.gfsoftindo.com/esupport/api/"
})